<template>
  <div class="w-100" id="RegistrationClientDetails">
    <h2 class="mb-4">My Details</h2>
    <error-banner v-if="error" :message="error"/>
    <name-fields v-model="clientName" :validator="clientValidator" :disabled="clientDetailsUpdated"/>
    <labeled-form-control label="Mobile">
        <input v-model="telephoneMobile" class="form-control" type="tel" placeholder="Mobile" :disabled="clientDetailsUpdated"/>
        <validation-message v-if="mobileValidation" :message="mobileValidation"/>
    </labeled-form-control>
    <address-field/>
    <medical-note/>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { ClientUpdateMixin } from '@/mixins/Registration/ClientUpdateMixin'
import { ClientOnboardingInviteCacheMixin } from '@/mixins/Registration/ClientOnboardingInviteCacheMixin'
import LabeledFormControl from '../../Layout/LabeledFormControl.vue'
import ValidationMessage from '../../ErrorValidation/ValidationMessage.vue'
import ErrorBanner from '../../ErrorValidation/ErrorBanner.vue'
import ClientNameFields from './ClientNameFields.vue'
import ClientAddressField from './ClientAddressField.vue'
import ClientMedicalNote from './ClientMedicalNote.vue'

export default {
  name: 'ClientDetailsSection',
  mixins: [ClientUpdateMixin, ClientOnboardingInviteCacheMixin],
  computed: {
    ...mapState('ApplicationEvents', [
      'saveRegistrationEvent'
    ]),
    clientName: {
      get () {
        return {
          firstName: this.firstName,
          lastName: this.lastName
        }
      },
      set (value) {
        this.firstName = value.firstName
        this.lastName = value.lastName
      }
    },
    clientDetailsUpdated () {
      return this.clientOnboardingInvite ? this.clientOnboardingInvite.clientDetailsUpdated : false
    }
  },
  watch: {
    saveRegistrationEvent () {
      if (!this.clientDetailsUpdated) {
        this.tryUpdateClient()
      }
    }
  },
  methods: {
    ...mapMutations('ClientOnboardingInvites', [
      'setClientDetailsUpdated'
    ]),
    afterUpdateClient () {
      this.setClientDetailsUpdated()
    }
  },
  components: {
    'labeled-form-control': LabeledFormControl,
    'name-fields': ClientNameFields,
    'address-field': ClientAddressField,
    'medical-note': ClientMedicalNote,
    'validation-message': ValidationMessage,
    'error-banner': ErrorBanner
  }
}
</script>
